document.addEventListener('DOMContentLoaded', () => {
  const glideContainer = document.querySelector('.glide__container');
  if (!glideContainer) return;

  const glideSlides = glideContainer.querySelectorAll('.glide__slide img');
  glideSlides.forEach(img => {
    if (!img) return;
    img.classList.add('f-zoomable');

    const existingWrapper = img.closest('a[data-fancybox="gallery"]');
    if (!existingWrapper) {
      const wrapper = document.createElement('a');
      wrapper.href = img.src;
      wrapper.setAttribute('data-fancybox', 'gallery');
      wrapper.classList.add('fancybox__slide');

      if (img.parentNode) {
        img.parentNode.insertBefore(wrapper, img);
        wrapper.appendChild(img);
      }
    }
  });

  function reinitPanzoomLazy() {
    document.querySelectorAll('.f-panzoom__content.f-lazyload.is-lazyloading').forEach(img => {
      const src = img.getAttribute('data-src') || img.getAttribute('src');
      if (!img.src && src) {
        img.src = src;
      }
      img.classList.remove('is-lazyloading');
      img.classList.add('is-lazyloaded');
    });
  }

  reinitPanzoomLazy();

  if (typeof Fancybox !== 'undefined') {
    Fancybox.destroy();

    Fancybox.bind('[data-fancybox="gallery"]', {
      Toolbar: { display: ["zoom", "fullscreen", "close"] },
      Image: { zoom: true, pan: true, wheel: "slide" },
      on: {
        ready: reinitPanzoomLazy,
        "Carousel.change": reinitPanzoomLazy
      }
    });
  }

  const bullets = glideContainer.querySelector('.glide__bullets');
  if (bullets) {
    let isDown = false, startX, scrollLeft;

    bullets.addEventListener('mousedown', e => {
      isDown = true;
      startX = e.pageX - bullets.offsetLeft;
      scrollLeft = bullets.scrollLeft;
    });

    bullets.addEventListener('mouseleave', () => isDown = false);
    bullets.addEventListener('mouseup', () => isDown = false);
    bullets.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - bullets.offsetLeft;
      const walk = x - startX;
      bullets.scrollLeft = scrollLeft - walk;
    });
  }
});
